export default __webpack_public_path__ + "static/media/HomeVideo.9e94d54c.mp4";